import { Typography } from '@mui/material'
import { useEffect } from 'react'
import { actions } from '../../ShedManagementState'
import { useDispatch } from 'react-redux'
import FormUpdateAttributesProducts from '../../components/FormUpdateAttributesProducts/FormUpdateAttributesProducts'
import FormSearchProducts from '../../../../components/FormSearchProducts/FormSearchProducts'
import * as S from './ShedManagementProducts.styles'

const ShedManagementProducts = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(actions.getAttributesGroup)
  }, [dispatch])

  return (
    <S.Wrapper>
      <Typography variant='h5' fontWeight='bold'>Gestão de atributos de produtos</Typography>
      <FormSearchProducts />
      <FormUpdateAttributesProducts />
    </S.Wrapper>
  )
}

export default ShedManagementProducts
